<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`/feature-gslc/ss/society`">社会服务</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/feature-gslc/ss/support`">技术支持</el-breadcrumb-item>
        <el-breadcrumb-item to="/feature-gslc/ss/support/faq">在线FAQ</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.Question }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content" ref="mainContainer">
        <div v-if="loaded">
          <h3 class="title">{{ model.Question }}</h3>
          <div class="content" v-html="model.Answer"></div>
          <div class="relative">
            <div class="prev">
              上一篇：
              <span v-if="prev" @click="handleSwitch(prev)" class="link-text text-over">
                {{ prev.Question }}
              </span>
              <span v-else>没有了</span>
            </div>
            <div class="next">
              下一篇：
              <span v-if="next" @click="handleSwitch(next)" class="link-text text-over">
                {{ next.Question }}
              </span>
              <span v-else>没有了</span>
            </div>
          </div>
        </div>
        <div class="error-data" v-else></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCurrentAndAdjacent } from "api/app";
import { Loading } from "element-ui";
import { mapState } from "vuex";

export default {
  data() {
    return {
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "1"
      },
      prev: null,
      next: null,
      id: null,
      name: "FAQ",
      loaded: false
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  },
  computed: {
    ...mapState("college", ["collegeData", "currentMajor"])
  },
  methods: {
    async loadData() {
      this.loaded = false;
      let loadingOptions = {
        target: this.$refs.mainContainer,
        fullscreen: false
      };
      let loadingInstance = Loading.service(loadingOptions);
      const res = await getCurrentAndAdjacent({ name: this.name, id: this.id, college: this.collegeData.college.Id });
      if (res) {
        this.model = res.current;
        this.prev = res.prev;
        this.next = res.next;
        this.loaded = true;
      } else {
        this.$message.error("异常数据");
      }
      loadingInstance.close();
    },
    init() {
      this.id = this.$route.params.id;

      this.loadData();
    },
    handleSwitch(item) {
      this.id = item.Id;
      this.loadData();
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 0 0 15px 0;
    line-height: 1.4em;
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 18px;
    padding-bottom: 24px;
    .time {
      padding-right: 30px;
    }
  }
  .content {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
  .relative {
    display: flex;
    justify-content: space-between;
    padding: 16px 0 40px 0;
    border-top: 1px solid #eee;
    margin-top: 40px;
    font-size: 16px;
    color: #999999;
    .link-text {
      max-width: 500px;
      cursor: pointer;
      &:hover {
        color: $primary-color;
      }
    }
    .prev {
      display: flex;
      flex: 1;
    }
    .next {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }
  }
}
</style>
